export function debounce(func, duration) {
  if (typeof func !== 'function') {
    throw new TypeError('Expected a function');
  }

  if (!duration || typeof duration !== 'number' || duration < 0) {
    throw new TypeError('Duration must be a positive number');
  }

  let timeout;

  return function(...args) {
    const effect = () => {
      timeout = null;
      return func.apply(this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(effect, duration);
  };
}
